import { get } from 'lodash';
import { FlowNode, Flow } from '../flowState';
import { isFlowTemplate } from 'app/beta-editor/utils/FlowUtils';
import hasInvalidMappings from './hasInvalidMappings';

const isValidFields = (node: FlowNode, flow: Flow) => {
  const areParamsValid = get(
    node.meta,
    ['validation', 'params', 'is_valid'],
    false
  );
  const areParamsOpened = get(
    node.meta,
    ['validation', 'params', 'is_opened'],
    false
  );

  const needs = (flow.needs || {})[node.id];
  const mappingsInvalid = hasInvalidMappings(node);
  const isZTUsingAppSampleData =
    isFlowTemplate(flow.nodes) && !node.authentication_id;
  return (
    isZTUsingAppSampleData ||
    (!mappingsInvalid &&
      ((needs && needs.length === 0) || (areParamsValid && areParamsOpened)))
  );
};

export default isValidFields;
